import { CoveragePremiumCoverageInterface, CoveragePremiumInterface } from '@app/core/interfaces';
import { type } from '@app/store/util';
import { Action } from '@ngrx/store';
import { Notification } from 'outshared-lib';

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const CLEAR = type('[my-zone container] clear calculation store');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const CLEAR_NOTIFICATIONS = type('[calculation-selector service] clear notifications');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const SET_NOTIFICATIONS = type('[calculation effects] set notifications');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const LOAD_CALCULATION = type('[product effects] load calculation');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const LOAD_CALCULATION_SUCCESS = type('[calculation effects] load calculation success');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const SELECT = type('[my-zone component] select calculation');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const CHANGE_GENERIC_PURCHASED_COVERAGES = type('[my-zone component] change generic purchased coverages');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const CHANGE_GENERIC_PURCHASED_COVERAGES_SUCCESS = type('[calculation effect] change generic purchased coverages success');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const CANCEL_FUTURE_PURCHASED_COVERAGE = type('[my-zone component] cancel future purchased coverage');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const CANCEL_FUTURE_PURCHASED_COVERAGE_SUCCESS = type('[calculation effects] cancel future purchased coverage success');

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class Clear implements Action {
    readonly type = CLEAR;
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class SetNotifications implements Action {
    readonly type = SET_NOTIFICATIONS;
    constructor(public payload: { notifications: Notification[] }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class ClearNotifications implements Action {
    readonly type = CLEAR_NOTIFICATIONS;
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class LoadCalculation implements Action {
    readonly type = LOAD_CALCULATION;
    constructor(public payload: { purchased_product_sequence_number: number } ) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class LoadCalculationSuccess implements Action {
    readonly type = LOAD_CALCULATION_SUCCESS;
    constructor(public payload: { purchased_product_sequence_number: number, calculation: CoveragePremiumInterface } ) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class Select implements Action {
    readonly type = SELECT;
    constructor(public payload: { afgenomen_product_volgnummer: number }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class ChangeGenericPurchasedCoverages implements Action {
    readonly type = CHANGE_GENERIC_PURCHASED_COVERAGES;
    constructor(public payload: {
        product_id: string,
        purchased_product_sequence_number: number,
        start_date: string,
        coverage_ids: {
            coverage_id: string,
        }[],
    }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class ChangeGenericPurchasedCoveragesSuccess implements Action {
    readonly type = CHANGE_GENERIC_PURCHASED_COVERAGES_SUCCESS;
    constructor(public payload: {
        purchased_product_sequence_number: number,
        start_date: string,
        purchased_coverages: CoveragePremiumCoverageInterface[],
    }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class CancelFuturePurchasedCoverage implements Action {
    readonly type = CANCEL_FUTURE_PURCHASED_COVERAGE;
    constructor(public payload: { purchased_product_sequence_number: number } ) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class CancelFuturePurchasedCoverageSuccess implements Action {
    readonly type = CANCEL_FUTURE_PURCHASED_COVERAGE_SUCCESS;
    constructor(public payload: {
        purchased_product_sequence_number: number,
        purchased_coverages: CoveragePremiumCoverageInterface[],
    }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export type CalculationsActions
    = Clear
    | LoadCalculation
    | LoadCalculationSuccess
    | SetNotifications
    | ClearNotifications
    | Select
    | ChangeGenericPurchasedCoverages
    | ChangeGenericPurchasedCoveragesSuccess
    | CancelFuturePurchasedCoverage
    | CancelFuturePurchasedCoverageSuccess;
